import { useState as M, useEffect as I, useCallback as m } from "react";
import { g as k, s as R, F as v } from "./MapView-C6gXpjuJ.js";
import { jsxs as E, jsx as h } from "react/jsx-runtime";
import { T as g, u as O, B as N } from "./useMediaQuery-BZAMobKw.js";
import { C as A } from "./Checkbox-CrXiJ6FE.js";
const Q = (t = !1) => {
  const [o, e] = M(t);
  return { isOpen: o, handleOpeningModal: () => e(!0), handleClosingModal: () => e(!1) };
}, U = (t) => {
  const [o, e] = M([]);
  I(() => {
    if (!t) return;
    const s = k(t);
    e((s == null ? void 0 : s.selectedTags) ?? []);
  }, [t]);
  const n = m(
    (s) => {
      e((c) => {
        const d = [...c].findIndex(
          (a) => {
            var r, i;
            return ((r = a.value) == null ? void 0 : r.toLowerCase()) === ((i = s.value) == null ? void 0 : i.toLowerCase());
          }
        );
        if (d > -1)
          return c.map(
            (a, r) => d === r ? { ...a, ...s } : a
          );
        {
          const a = [...c, s];
          return f(t, a), a;
        }
      });
    },
    [t]
  ), l = m(
    (s) => {
      e((c) => {
        if ([...c].some(
          (a) => {
            var r, i;
            return ((r = a.value) == null ? void 0 : r.toLowerCase()) === ((i = s.value) == null ? void 0 : i.toLowerCase());
          }
        )) {
          if (s.type !== "addressType") {
            const a = c.filter(
              (r) => {
                var i, _;
                return ((i = r.value) == null ? void 0 : i.toLowerCase()) !== ((_ = s.value) == null ? void 0 : _.toLowerCase());
              }
            );
            return f(t, a), a;
          }
          return c;
        } else {
          const a = [...c, s];
          return f(t, a), a;
        }
      });
    },
    [t]
  ), u = m(
    (s) => {
      e((c) => {
        const d = c.filter(
          (a) => {
            var r, i;
            return ((r = a.value) == null ? void 0 : r.toLowerCase()) !== ((i = s.value) == null ? void 0 : i.toLowerCase());
          }
        );
        return f(t, d, s), d;
      });
    },
    [t]
  ), p = m(
    (s) => {
      e((c) => {
        const d = c.filter(
          (a) => a.type.toLowerCase() !== s.toLowerCase()
        );
        return f(t, d), d;
      });
    },
    [t]
  ), w = m(() => {
    e([]), f(t, []);
  }, [t]), b = m(
    (s) => {
      e((c) => {
        const d = c.findIndex(
          (r) => {
            var i, _;
            return ((i = r.type) == null ? void 0 : i.toLowerCase()) === ((_ = s.type) == null ? void 0 : _.toLowerCase());
          }
        );
        if (d === -1) {
          const r = [...c, s];
          return f(t, r, s), r;
        }
        const a = c.map(
          (r, i) => d === i ? { ...r, value: s.value } : r
        );
        return f(t, a, s), a;
      });
    },
    [t]
  );
  return {
    selectedTags: o,
    addOrUpdateTag: n,
    toggleTag: l,
    removeTag: u,
    removeAllTags: w,
    removeTagsByType: p,
    addUniqueTagOfType: b
  };
};
function f(t, o, e) {
  if (!t) return;
  const n = k(t);
  R(t, {
    ...n,
    selectedTags: o,
    searchQuery: (e == null ? void 0 : e.value) === (n == null ? void 0 : n.searchQuery) ? "" : n == null ? void 0 : n.searchQuery
  });
}
const Y = ({
  noResultHeadingText: t,
  noResultParagraphText: o
}) => /* @__PURE__ */ E("div", { children: [
  /* @__PURE__ */ h(g, { type: "heading", size: "small", children: t }),
  /* @__PURE__ */ h(g, { type: "paragraph", size: "large", children: o })
] }), L = {
  "page-title": "elo-page-title",
  "page-title__title": "elo-page-title__title"
}, z = ({
  pageTitle: t,
  isDisplayingMapView: o,
  openMapViewButtonText: e,
  openCardViewButtonText: n,
  onClickMapView: l,
  disableMapView: u = !1
}) => {
  const p = O("(max-width: 490px)");
  return /* @__PURE__ */ E("div", { className: L["page-title"], children: [
    /* @__PURE__ */ h(
      g,
      {
        type: "display",
        size: "small",
        extraClass: L["page-title__title"],
        children: t
      }
    ),
    !p && /* @__PURE__ */ h(
      N,
      {
        iconLeft: o ? "Image" : "Map",
        onClick: l,
        disabled: u,
        children: o ? n : e
      }
    )
  ] });
}, D = "sortByOptionsSessionStorageKey", G = "locations", H = "apartment-locations", T = {
  "dropdown-checkbox-list": "elo-dropdown-checkbox-list",
  "dropdown-checkbox-list__item": "elo-dropdown-checkbox-list__item"
}, J = ({
  items: t
}) => t.length > 0 && /* @__PURE__ */ h("ul", { className: T["dropdown-checkbox-list"], children: t && t.map((o, e) => /* @__PURE__ */ h("li", { className: T["dropdown-checkbox-list__item"], children: /* @__PURE__ */ h(A, { ...o }) }, e)) }), x = {
  "dropdown-filter-list": "elo-dropdown-filter-list",
  "dropdown-filter-list__item": "elo-dropdown-filter-list__item"
}, S = ({
  items: t
}) => t.length > 0 && /* @__PURE__ */ h("ul", { className: x["dropdown-filter-list"], children: t && t.map((o, e) => /* @__PURE__ */ h("li", { className: x["dropdown-filter-list__item"], children: /* @__PURE__ */ h(v, { ...o }) }, e)) }), V = async (t, o, e) => {
  try {
    const n = window.location.href, l = new URL(t, n);
    o && l.searchParams.set("language", o);
    const u = await fetch(l.toString(), {
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        __RequestVerificationToken: e
      }
    });
    if (!u.ok)
      throw new Error(`Error fetching locations: ${u.statusText}`);
    return await u.json();
  } catch (n) {
    throw console.error("Error fetching locations:", n), n;
  }
}, W = async (t, o) => {
  const e = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(t)}&key=${o}`;
  try {
    const n = await fetch(e);
    if (!n.ok)
      throw new Error(`HTTP error! status: ${n.status}`);
    const l = await n.json();
    if (l.results && l.results.length > 0 && l.results[0].geometry && l.results[0].geometry.location && l.results[0].address_components) {
      const p = l.results[0].address_components.find(
        (w) => w.types.includes("country")
      );
      if (p && p.short_name === "FI")
        return {
          lat: l.results[0].geometry.location.lat,
          lng: l.results[0].geometry.location.lng
        };
    }
    return null;
  } catch (n) {
    return console.error("Error fetching coordinates:", n), null;
  }
}, B = 6371;
function X(t, o) {
  if (!t || !o || t.lat === o.lat && t.lng === o.lng)
    return 0;
  const e = C(o.lat - t.lat), n = C(o.lng - t.lng), l = C(t.lat), u = C(o.lat), p = Math.sin(e / 2) * Math.sin(e / 2) + Math.sin(n / 2) * Math.sin(n / 2) * Math.cos(l) * Math.cos(u), w = 2 * Math.atan2(Math.sqrt(p), Math.sqrt(1 - p));
  return Math.abs(B * w);
}
function C(t) {
  return t * (Math.PI / 180);
}
function Z(t) {
  return t = t == null ? void 0 : t.trim(), (t == null ? void 0 : t.toLowerCase()) === "pääkaupunkiseutu" ? "helsinki" : t;
}
export {
  S as D,
  G as L,
  Y as N,
  z as P,
  D as S,
  J as a,
  Z as b,
  X as c,
  U as d,
  H as e,
  W as f,
  V as g,
  Q as u
};
